
import Layout from './components/Layout'
import LayoutColumn from './components/LayoutColumn'

export default Layout;

export {
  LayoutColumn
}